import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { create } from '~/actions/bundles';
import Input from 'react-toolbox/lib/input';
import ArticlePicker from '~/components/ArticlePicker';
import RawMaterialPicker from '~/components/RawMaterialPicker';
import MultiPickerCount from '~/components/MultiPickerCount';
import styleDialog from '~/style/dialog.scss';

const MultiArticlePicker = MultiPickerCount(ArticlePicker);
const MultiRawMaterialPicker = MultiPickerCount(RawMaterialPicker);

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      articleIds: {},
      rawMaterialIds: {}
    };
  }

  submit() {
    return create(this.props.dispatch, this.context.apiClient, this.state)
      .then(() => this.context.dialogClose(this.props.dialogId))
      .then(() => this.props.data.onCreate && this.props.data.onCreate());
  }

  render() {
    return (
      <div className={[styleDialog.background, styleDialog[this.props.transition]].join(' ')} onClick={() => this.context.dialogClose(this.props.dialogId)}>
        <div className={styleDialog.container} onClick={e => e.stopPropagation()}>
          <IconButton className={styleDialog.closeButton} icon="close" onClick={() => this.context.dialogClose(this.props.dialogId)} />
          <div className={styleDialog.content}>
            <form onSubmit={e => { e.preventDefault(); this.submit(); }}>
              <Input label="Name" required value={this.state.name} onChange={name => this.setState({ name })} />
              <Input label="UPC" required value={this.state.upc} onChange={upc => this.setState({ upc })} />
              <div>Articles</div>
              <MultiArticlePicker
                value={this.state.articleIds}
                onChange={v =>
                  this.setState({ articleIds: v })}
              />
              <div>Raw materials</div>
              <MultiRawMaterialPicker
                value={this.state.rawMaterialIds}
                onChange={v =>
                  this.setState({ rawMaterialIds: v })}
              />
              <Button label="Create" type="submit" primary raised />
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default connect()(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/BundleNew/index.js